export default class LowWaterStationDto {
    constructor(obj = {}) {
        this.code = obj.code
        this.headers = ['code']
    }
}